<script setup>
import { onMounted, defineProps, defineEmits, ref } from 'vue';

const emit = defineEmits(['changeYear', 'changeType']);

const props = defineProps({
  events: {
    type: Array,
    default: () => []
  },
  typesVisible: {
    type: Boolean,
    default: true,
  },
})

const selectedYear = ref(undefined);
const selectedType = ref(undefined);
const years = ref(undefined);
const types = [
  {name: 'online', title: 'Онлайн'},
  {name: 'offline', title: 'Офлайн'},
]

const getEventYears = (events) => {
  if (!events) {
    return [ new Date().getFullYear().toString() ];
  }
  return [...new Set(events.map(e => new Date(e.date_start).getFullYear()))];
}

const switchYear = (value) => {
  selectedYear.value = value;
  emit('changeYear', value);
}
const switchType = (value) => {
  selectedType.value = value;
  emit('changeType', value);
}

onMounted(() => {
  years.value = getEventYears(props.events);
  const currentYear = new Date().getFullYear();
  const yearToShow = years.value.includes(currentYear) ? currentYear : years.value[0];
  switchYear(yearToShow);
})

</script>
<template>
  <div class="events-filters">
    <div class="events-filters__years">
      <a
          href=""
          v-for="tab in years"
          :key="tab"
          :class="['events-filters__year', {'events-filters__year_selected': tab === selectedYear}]"
          @click.prevent="switchYear(tab); selectedType = undefined;"
      >
        {{ tab }} год
      </a>
    </div>
    <div class="events-filters__years-divider" aria-hidden="true"></div>
    <div class="events-filters__types" v-if="typesVisible">
      <a
          href=""
          @click.prevent="switchType(undefined)"
          :class="['events-filters__type', {'events-filters__type_selected': !selectedType}]"
      >
        Все
      </a>
      <a
          href=""
          v-for="type in types"
          :key="type.name"
          @click.prevent="switchType(type.name)"
          :class="['events-filters__type', {'events-filters__type_selected': type.name === selectedType}]"
      >
        {{ type.title }}
      </a>
    </div>
    <!--div class="events-filters__search">
      <input type="search" placeholder="Найти мероприятие" name="event_search" class="events-filters__search-input" />
      <button class="events-filters__search-button" value=""/>
    </div-->
  </div>
</template>